/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll';
import Bubble from './scroll-bubble';
export default {
  name: 'vue-better-scroll',
  props: {
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    listenBeforeScroll: {
      type: Boolean,
      default: false
    },
    scrollbar: {
      type: Boolean,
      default: false
    },
    pullDownRefresh: {
      type: [Object, Boolean],
      default: function _default() {
        return {
          threshold: 90,
          stop: 40
        };
      }
    },
    pullUpLoad: {
      type: [Object, Boolean],
      default: function _default() {
        return {
          threshold: 90,
          txt: {
            more: i18n.tc("353"),
            noMore: i18n.tc("275")
          }
        };
      }
    },
    startY: {
      type: Number,
      default: 0
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    freeScroll: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullDownInitTop: {
      type: Number,
      default: -50
    }
  },
  components: {
    Bubble: Bubble
  },
  data: function data() {
    return {
      beforePullDown: true,
      isRebounding: false,
      isPullingDown: false,
      pulling: false,
      isPullUpLoad: false,
      pullUpDirty: true,
      // 是否有下一页
      pullDownStyle: '',
      bubbleY: 0,
      reboundPullDownTimer: null,
      afterPullDownTimer: null
    };
  },
  computed: {
    isOverFlow: function isOverFlow() {
      var wrap = this.$refs['scroll-content'] || {};
      var ctx = this.$refs['wrapper'] || {};
      return wrap.clientHeight >= ctx.clientHeight;
    },
    noData: function noData() {
      return !!document.querySelector('.scroll-wrapper .no-result');
    },
    pullUpTxt: function pullUpTxt() {
      var moreTxt = this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.more || i18n.tc("353");
      var noMoreTxt = this.pullUpLoad && this.pullUpLoad.txt && this.pullUpLoad.txt.noMore || i18n.tc("275");
      return this.pullUpDirty ? moreTxt : noMoreTxt;
    },
    refreshTxt: function refreshTxt() {
      return this.pullDownRefresh && this.pullDownRefresh.txt || '';
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.initScroll();
    });
  },
  methods: {
    // 滚动到顶部
    scrollToTop: function scrollToTop() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.scrollTo(0, 0, 500);
      });
    },
    initScroll: function initScroll() {
      var _this3 = this;
      if (!this.$refs.wrapper) {
        return false;
      }
      var options = Object.assign({}, this.options, {
        probeType: this.probeType,
        click: this.click,
        scrollY: true,
        // 下拉刷新组件 只能纵向 不能横向
        scrollX: false,
        scrollbar: this.scrollbar,
        pullDownRefresh: this.pullDownRefresh,
        pullUpLoad: this.pullUpLoad,
        startY: this.startY,
        freeScroll: this.freeScroll
      });
      this.scroll = new BScroll(this.$refs.wrapper, options);
      if (this.listenScroll) {
        this.scroll.on('scroll', function (pos) {
          _this3.$emit('scroll', pos);
        });
      }
      if (this.listenBeforeScroll) {
        this.scroll.on('beforeScrollStart', function () {
          _this3.$emit('before-scroll-start');
        });
      }
      if (this.pullDownRefresh) {
        this._initPullDownRefresh();
      }
      if (this.pullUpLoad) {
        this._initPullUpLoad();
      }
    },
    disable: function disable() {
      this.scroll && this.scroll.disable();
    },
    enable: function enable() {
      this.scroll && this.scroll.enable();
    },
    refresh: function refresh() {
      this.scroll && this.scroll.refresh();
    },
    scrollTo: function scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement: function scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    },
    destroy: function destroy() {
      this.scroll && this.scroll.destroy();
    },
    // 加载数据后更新
    forceUpdate: function forceUpdate(dirty) {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.pullUpDirty = dirty;
        if (_this4.pullDownRefresh && _this4.isPullingDown) {
          _this4.pulling = false;
          _this4._reboundPullDown().then(function () {
            _this4._afterPullDown();
          });
        } else if (_this4.pullUpLoad) {
          _this4.isPullUpLoad = false;
          _this4.scroll.finishPullUp && _this4.scroll.finishPullUp();
          _this4.refresh();
        } else {
          _this4.refresh();
        }
      });
    },
    isHasMore: function isHasMore(dirty) {
      return this.forceUpdate(dirty);
    },
    _initPullDownRefresh: function _initPullDownRefresh() {
      var _this5 = this;
      this.scroll.on('pullingDown', function () {
        _this5.beforePullDown = false;
        _this5.isPullingDown = true;
        _this5.pulling = true;
        _this5.$emit('pulling-down');
      });
      this.scroll.on('scroll', function (pos) {
        if (_this5.beforePullDown) {
          _this5.bubbleY = Math.max(0, pos.y + _this5.pullDownInitTop / 2);
          _this5.pullDownStyle = "top:".concat(Math.min(pos.y + _this5.pullDownInitTop, 10), "px");
        } else {
          _this5.bubbleY = 0;
        }
        if (_this5.isRebounding) {
          _this5.pullDownStyle = "top:".concat(10 - (_this5.pullDownRefresh.stop - pos.y), "px");
        }
      });
    },
    _initPullUpLoad: function _initPullUpLoad() {
      var _this6 = this;
      this.scroll.on('pullingUp', function (e) {
        if (_this6.pullUpDirty) {
          _this6.isPullUpLoad = true;
          _this6.$emit('pulling-up');
        }
      });
    },
    _reboundPullDown: function _reboundPullDown() {
      var _this7 = this;
      var _this$pullDownRefresh = this.pullDownRefresh.stopTime,
        stopTime = _this$pullDownRefresh === void 0 ? 600 : _this$pullDownRefresh;
      return new Promise(function (resolve) {
        _this7.reboundPullDownTimer = setTimeout(function () {
          _this7.isRebounding = true;
          _this7.isPullingDown = false;
          _this7.scroll.finishPullUp();
          _this7.scroll.finishPullDown();
          resolve();
        }, stopTime);
      });
    },
    _afterPullDown: function _afterPullDown() {
      var _this8 = this;
      this.afterPullDownTimer = setTimeout(function () {
        _this8.pullDownStyle = "top:".concat(_this8.pullDownInitTop, "px");
        _this8.beforePullDown = true;
        _this8.isRebounding = false;
        _this8.refresh();
      }, this.scroll.options.bounceTime);
    }
  },
  destroyed: function destroyed() {
    this.scroll && this.scroll.destroy();
    this.scroll = null;
    this.reboundPullDownTimer && clearTimeout(this.reboundPullDownTimer);
    this.reboundPullDownTimer = null;
    this.afterPullDownTimer && clearTimeout(this.afterPullDownTimer);
    this.afterPullDownTimer = null;
  }
};